module.exports = __webpack_public_path__ + "img/pagsmile-logo.a4096a5.png";